import { ComponentPropsWithRef } from "react";
import { semanticGreen, shade0 } from "../../../../styles/tokens";

export const SuccessIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="24" fill={semanticGreen} />
    <path
      d="M20.4898 31.8894L14.7977 26.1973C14.5674 25.9671 14.5674 25.5928 14.7977 25.3626L17.3019 22.8583C17.5322 22.6281 17.9064 22.6281 18.1367 22.8583L20.4898 25.2114C20.72 25.4417 21.0943 25.4417 21.3245 25.2114L29.8633 16.6727C30.0936 16.4424 30.4678 16.4424 30.6981 16.6727L33.2023 19.1769C33.4326 19.4072 33.4326 19.7814 33.2023 20.0117L21.3245 31.8894C21.0943 32.1197 20.72 32.1197 20.4898 31.8894Z"
      fill={shade0}
    />
  </svg>
);
